import { render, staticRenderFns } from "./ai-insight.vue?vue&type=template&id=21b48358&scoped=true&lang=pug&"
import script from "./ai-insight.vue?vue&type=script&lang=ts&"
export * from "./ai-insight.vue?vue&type=script&lang=ts&"
import style0 from "./ai-insight.vue?vue&type=style&index=0&id=21b48358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b48358",
  null
  
)

export default component.exports